// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"315":"plugin.echarts","371":"plugin.networkgraph","725":"module.admin"}[chunkId] + ".css?v=" + {"315":"0fc79fa81136ef998927","371":"258f6916281c2393322d","725":"1e461fa4845649540e9f"}[chunkId] + "";
};